import FormContainer from "./tables/deposit/FormContainer";

export default function TableInv() {
  return (
    <div className="p-3">
      <FormContainer/>
    </div>
  );
}